import axios from 'axios'
import { hostUI } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
    records: [],
    pagination: {
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        limit: 10
    },
    loading: false,
    error: null
}

const OBTENER_GRANEL_LISTA = 'bitacoraEnvasadoGranel/obtenerLista'
const GUARDAR_GRANEL_RECORD = 'bitacoraEnvasadoGranel/guardarRecord'
const FUSIONAR_GRANEL_RECORDS = 'bitacoraEnvasadoGranel/fusionarRecords'

export const obtenerGranelRecords = createAsyncThunk(
    OBTENER_GRANEL_LISTA,
    async (params, { rejectWithValue }) => {
        try {
            let idLogin = null;
            let page = 1;
            let limit = 20;
            let search = '';

            if (typeof params === 'object' && params !== null) {
                idLogin = params.idLogin || params.id_login || null;
                page = params.page || 1;
                limit = params.limit || 20;
                search = params.search || '';
            } else {
                idLogin = params;
            }

            const queryParts = [];
            if (idLogin) queryParts.push(`id_login=${idLogin}`);
            if (page) queryParts.push(`page=${page}`);
            if (limit) queryParts.push(`limit=${limit}`);
            if (search) queryParts.push(`search=${encodeURIComponent(search)}`);

            const queryString = queryParts.length ? `?${queryParts.join('&')}` : '';
            const url = `${hostUI}bitacora-envasado/granel${queryString}`;

            const res = await axios.get(url);
            return {
                records: res.data.data || [],
                pagination: res.data.pagination || { totalRecords: (res.data.data || []).length, totalPages: 1, currentPage: 1, limit: 20 }
            };
        } catch (error) {
            console.error("Error al obtener registros de envasado granel:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const guardarGranelRecord = createAsyncThunk(
    GUARDAR_GRANEL_RECORD,
    async (recordData, { rejectWithValue }) => {
        try {
            const url = `${hostUI}bitacora-envasado/granel`;
            const res = await axios.post(url, recordData);
            return res.data.data;
        } catch (error) {
            console.error("Error al guardar envasado granel:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const fusionarGranelRecords = createAsyncThunk(
    FUSIONAR_GRANEL_RECORDS,
    async (fusionData, { rejectWithValue }) => {
        try {
            const url = `${hostUI}bitacora-envasado/granel/mezclar`;
            const res = await axios.post(url, fusionData);
            return res.data.data;
        } catch (error) {
            console.error("Error al fusionar graneles:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

const bitacoraEnvasadoGranelSlice = createSlice({
    name: 'bitacoraEnvasadoGranel',
    initialState,
    reducers: {
        resetGranelError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(obtenerGranelRecords.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(obtenerGranelRecords.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records = payload.records;
                state.pagination = payload.pagination;
            })
            .addCase(obtenerGranelRecords.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            .addCase(guardarGranelRecord.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records.unshift(payload);
            })
            .addCase(fusionarGranelRecords.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.records.unshift(payload);
            });
    }
});

export const { resetGranelError } = bitacoraEnvasadoGranelSlice.actions;
export default bitacoraEnvasadoGranelSlice.reducer;
